const ImageCloud = "http://motiwalabuilders.online/GetImage/Metropolis"

export default ImageCloud